module.exports = __webpack_public_path__ + "media/images/front/icon_post-pc-0459f928679558d2d8c62b637c74a68f.png";